<p-card [style]="{ margin: 0, height: '100%' }">
  <div class="flex align-items-center gap-2 mb-3">
    <i class="pi pi-file-edit text-xl"></i>
    <h2 class="m-0">Logs applicatifs</h2>
  </div>

  <!-- Sélecteur de fichier -->
  <div class="flex align-items-center gap-2 mb-3 flex-wrap">
    <label class="font-semibold">Fichier :</label>
    <p-dropdown
      [options]="(files$ | async) || []"
      [(ngModel)]="selectedFile"
      optionLabel="name"
      optionValue="name"
      (onChange)="onFileChange()"
      [loading]="(filesLoading$ | async) ?? false"
      placeholder="Sélectionner un fichier"
      [style]="{ minWidth: '220px' }"
    >
      <ng-template pTemplate="item" let-f>
        <div class="flex flex-column">
          <span class="font-medium">{{ f.name }}</span>
          <span class="text-xs text-color-secondary">{{ formatSize(f.size) }}</span>
        </div>
      </ng-template>
    </p-dropdown>
  </div>

  <!-- Filtres -->
  <div class="flex gap-2 mb-3 flex-wrap align-items-center">
    <p-dropdown
      [options]="levelOptions"
      [(ngModel)]="filterLevel"
      optionLabel="label"
      optionValue="value"
      (onChange)="onFilter()"
      [style]="{ minWidth: '180px' }"
    ></p-dropdown>

    <input
      pInputText
      [(ngModel)]="filterSearch"
      placeholder="Rechercher dans les messages…"
      class="filter-input"
      (keyup.enter)="onFilter()"
    />

    <p-button
      icon="pi pi-search"
      label="Filtrer"
      (onClick)="onFilter()"
      severity="secondary"
    ></p-button>

    <p-button
      icon="pi pi-times"
      label="Réinitialiser"
      (onClick)="onReset()"
      severity="secondary"
      [outlined]="true"
    ></p-button>

    <p-button
      icon="pi pi-refresh"
      label="Actualiser"
      (onClick)="loadEntries()"
      severity="secondary"
      [outlined]="true"
    ></p-button>
  </div>

  <!-- Tableau des entrées -->
  <p-table
    [value]="(entries$ | async) || []"
    [loading]="(loading$ | async) ?? false"
    [lazy]="true"
    [paginator]="true"
    [rows]="50"
    [rowsPerPageOptions]="[25, 50, 100, 200]"
    [totalRecords]="(total$ | async) || 0"
    (onLazyLoad)="onLazyLoad($event)"
    styleClass="p-datatable-sm"
    [scrollable]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 160px">Date</th>
        <th style="width: 90px">Niveau</th>
        <th style="width: 80px">Env</th>
        <th>Message</th>
        <th style="width: 60px"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-entry>
      <tr [class]="'log-row log-' + entry.level">
        <td class="text-xs text-nowrap">{{ entry.timestamp }}</td>
        <td>
          <p-tag
            [value]="entry.level | uppercase"
            [severity]="getLevelSeverity(entry.level)"
          ></p-tag>
        </td>
        <td>
          <code class="text-xs">{{ entry.env }}</code>
        </td>
        <td class="message-cell">
          <span [pTooltip]="entry.message" tooltipPosition="top" [tooltipOptions]="{ tooltipStyleClass: 'log-tooltip' }">
            {{ entry.message }}
          </span>
        </td>
        <td>
          <p-button
            icon="pi pi-eye"
            [rounded]="true"
            [text]="true"
            severity="secondary"
            (onClick)="openDetail(entry)"
            pTooltip="Voir le détail"
            tooltipPosition="left"
          ></p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center py-4 text-color-secondary">
          Aucune entrée trouvée.
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>

<!-- Dialogue de détail -->
<p-dialog
  [(visible)]="showDetailDialog"
  header="Détail de l'entrée"
  [modal]="true"
  [style]="{ width: '80vw', maxWidth: '900px' }"
  [closable]="true"
>
  @if (selectedEntry) {
    <div class="flex flex-column gap-3">
      <div class="flex gap-4 flex-wrap">
        <div>
          <span class="font-semibold">Date : </span>
          <span>{{ selectedEntry.timestamp }}</span>
        </div>
        <div>
          <span class="font-semibold">Niveau : </span>
          <p-tag
            [value]="selectedEntry.level | uppercase"
            [severity]="getLevelSeverity(selectedEntry.level)"
          ></p-tag>
        </div>
        <div>
          <span class="font-semibold">Environnement : </span>
          <code>{{ selectedEntry.env }}</code>
        </div>
      </div>

      <div>
        <p class="font-semibold mb-1">Message :</p>
        <pre class="log-pre">{{ selectedEntry.message }}</pre>
      </div>

      @if (selectedEntry.context) {
        <div>
          <p class="font-semibold mb-1">Contexte / Stack trace :</p>
          <pre class="log-pre log-pre--context">{{ selectedEntry.context }}</pre>
        </div>
      }
    </div>
  }
</p-dialog>
